import { TitleCasePipe } from '@angular/common';
import { Component, Inject, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { EnrollmentReportStudent } from 'src/app/component/child-reports/enrollment-report/model/enrollment-report-result.model';
import { MsgModel } from 'src/app/component/common-components/msg/model/msg.model';
import { QuestionHelpText } from 'src/app/model/question-help-text';
import { CleanDatePipe } from 'src/app/pipes/clean-date.pipe';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { SimpleDatePipe } from 'src/app/pipes/simple-date.pipe';
import { StudentTerminationsService } from '../../service/student-terminations.service';
import { UntypedFormBuilder } from '@angular/forms';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StudentSchoolEnrollmentService } from '../../service/student-school-enrollment.service';
import { StudentService } from '../../service/student.service';
import { MatPaginator } from '@angular/material/paginator';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-graduate-student-school-enrollment-modal',
    templateUrl: './graduate-student-school-enrollment-modal.component.html',
    styleUrls: ['./graduate-student-school-enrollment-modal.component.scss']
})
export class GraduateStudentSchoolEnrollmentModalComponent implements OnInit {
    @Input() students!: EnrollmentReportStudent[];

    @ViewChildren(MatPaginator) paginators: QueryList<MatPaginator> = new QueryList<MatPaginator>();

    // Reference Data
    removeGraduatedChildren: boolean = false;
    graduationDate: Date = new Date();

    graduationDateOptions = {
        maxDate: new Date(),
        startAt: new Date()
    };

    graduatingStudents: any[] = [];
    duplicateStudents: any[] = [];
    uniqueStudents: any[] = [];

    // Table results
    tableDataSources: MatTableDataSource<any>[] = [];

    // Table display
    displayedColumns = ['EDIT', 'GRADUATION_CHECK', 'NAME', 'MSD_NUMBER'];

    // Component letiables
    resetField: boolean = false;

    isLoading: boolean = false;
    isSaving: boolean = false;
    isSubmitting: boolean = false;

    promises: Array<any> = [];

    msg: MsgModel;

    // Help Text
    lstQuestionHelpText: QuestionHelpText[] = [];

    // Pipes
    cleanDatePipe: CleanDatePipe = new CleanDatePipe();
    simpleDatePipe: SimpleDatePipe = new SimpleDatePipe();
    getPropertyPipe: GetPropertyPipe = new GetPropertyPipe();
    titlecasePipe: TitleCasePipe = new TitleCasePipe();

    constructor(
        public dialogRef: MatDialogRef<GraduateStudentSchoolEnrollmentModalComponent>,
        private dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private fb: UntypedFormBuilder,
        private studentSchoolEnrollmentService: StudentSchoolEnrollmentService,
        private studentService: StudentService,
        private studentTerminationsService: StudentTerminationsService
    ) {}

    ngOnInit(): void {
        this.isLoading = true;

        // Use data IDs if exists
        if (this.data) {
            this.students = this.data.students;
        }

        // Needed
        this.getGroupCurrentStudentTerminationStatuses(this.students);

        Promise.all(this.promises).then((res) => {
            this.buildGraduatingStudents();
            this.updateDataSource();

            this.isLoading = false;
        });
    }

    getGroupCurrentStudentTerminationStatuses(students: any[]) {
        let deferred = new Promise((resolve, reject) => {
            this.studentTerminationsService.getGroupCurrentStudentTerminationStatuses(students).subscribe((res) => {
                if (res.students) {
                    this.students = this.mergeArrays(this.students, JSON.parse(res.students), ['ID', 'STUDENT_TERMINATION_STATUSES']);
                    resolve(res);
                } else if (res?.msg) {
                    resolve(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    buildGraduatingStudents() {
        this.graduatingStudents = [];

        this.uniqueStudents = this.resolveDuplicateStudents(this.students);

        this.uniqueStudents.forEach((us) => {
            this.addStudent(us);
        });
    }

    resolveDuplicateStudents(students: any[]) {
        let uniques = [...new Map(students.map((s) => [s['ID'], s])).values()];
        this.duplicateStudents = this.getDuplicateStudents();

        return uniques;
    }

    getDuplicateStudents() {
        let groupedBy = this.groupBy(this.students, 'ID');
        let duplicateStudents = [];

        for (let propertyName in groupedBy) {
            if (groupedBy[propertyName].length > 1) {
                groupedBy[propertyName][0].SIZE = groupedBy[propertyName].length;
                duplicateStudents.push(groupedBy[propertyName][0]);
            }
        }

        return duplicateStudents;
    }

    groupBy(xs: any[], key: string) {
        return xs.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    }

    addStudent(student: any) {
        if (this.removeGraduatedChildren) {
            if (student && student.STUDENT_TERMINATION_STATUSES && student.STUDENT_TERMINATION_STATUSES.length > 0) {
                return;
            }
        }

        this.graduatingStudents.push(this.minifyStudent(student));
    }

    minifyStudent(student: any) {
        var graduated = this.checkGraduated(student);
        return {
            ID: student.ID,
            ENABLED: !graduated,
            GRADUATED: graduated,
            NAME: this.getStudentName(student),
            MSD_NUMBER: student.MSD_NUMBER,
            SCHOOL_ENROLLMENTS_ID:
                student.SCHOOL_ENROLLMENT_DETAILS && student.SCHOOL_ENROLLMENT_DETAILS.length > 0 ? student.SCHOOL_ENROLLMENT_DETAILS[0].ID : 0
        };
    }

    mergeArrays(targetArray: any[], mergingArray: any[], propertiesToMerge: string[]) {
        if (propertiesToMerge) {
            mergingArray.forEach((obj) => {
                for (let propertyName in obj) {
                    if (
                        !propertiesToMerge.find((property) => {
                            return property === propertyName;
                        })
                    ) {
                        delete obj[propertyName];
                    }
                }
            });
        }

        let result: any[] = targetArray.map((obj) => {
            return Object.assign(
                obj,
                mergingArray.find((ma) => ma.ID === obj.ID)
            );
        });

        return result;
    }
    /****************************************************************************************
 		Boolean Functions
	****************************************************************************************/
    checkGraduated(student: any) {
        let studentFound = this.students.find((s: any) => s.ID === student.ID);

        if (studentFound && studentFound.STUDENT_TERMINATION_STATUSES && studentFound.STUDENT_TERMINATION_STATUSES.length > 0) {
            return studentFound.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES.ID === 2;
        } else {
            return false;
        }
    }
    isTerminated(student: any) {
        let studentFound = this.students.find((s: any) => s.ID === student.ID);

        if (studentFound && studentFound.STUDENT_TERMINATION_STATUSES && studentFound.STUDENT_TERMINATION_STATUSES.length > 0) {
            if (studentFound.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES.ID !== 1) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }
    hasAtLeastOneStudent() {
        let found = false;

        found = this.graduatingStudents.find((student: any) => student.ENABLED);

        return !!found;
    }

    /****************************************************************************************
 		Add Functions
	****************************************************************************************/
    graduate() {
        this.isSubmitting = true;
        if (this.checkValid()) {
            this.isLoading = true;

            this.studentSchoolEnrollmentService.graduate(this.graduationDate, this.resolveOnlyChosenStudents()).subscribe({
                next: (res) => {
                    if (res.msg) {
                        if (res.msg.SUCCESS) {
                            this.msg = res.msg;

                            this.msg.MSG += ' (closing modal in 3 seconds...)';
                            setTimeout(() => {
                                this.dialogRef.close({ refresh: true });
                            }, 3000);
                        } else {
                            this.msg = res.msg;
                        }
                    } else {
                        this.msg = { MSG: 'There was an error graduating these child enrollments.', SUCCESS: false };
                    }
                },
                error: (err) => {
                    if (err.msg) {
                        this.msg = err.msg;
                    } else {
                        this.msg = { MSG: 'Server error.', SUCCESS: false };
                    }
                },
                complete: () => {
                    this.isSubmitting = false;
                }
            });
        } else {
            this.msg = { MSG: 'Please check your inputs.', SUCCESS: false };
            this.isSubmitting = false;
        }
    }

    checkValid() {
        let valid = true;

        if (this.hasAtLeastOneStudent()) {
            if (!this.graduationDate) {
                return (valid = false);
            }
        } else {
            valid = false;
        }

        return valid;
    }

    resolveOnlyChosenStudents() {
        let returnStudents = JSON.parse(JSON.stringify(this.graduatingStudents));

        returnStudents = returnStudents.filter((student: any) => {
            return student.ENABLED;
        });

        return returnStudents;
    }

    /****************************************************************************************
		Table Functions
	****************************************************************************************/
    updateDataSource(newSort?: boolean) {
        setTimeout(() => {
            this.tableDataSources = [];

            // Data
            let dataSource = new MatTableDataSource<any>();
            dataSource.data = this.graduatingStudents.sort((n1: any, n2: any) => (n1.NAME! > n2.NAME! ? 1 : -1));

            // Paginator
            dataSource.paginator = this.paginators.toArray()[0];

            // Sort
            // dataSource.sort = this.sorts.toArray()[index];
            // dataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);
            // if (newSort) {
            //     const defaultSort: Sort = { active: 'NAME', direction: 'asc' };
            //     dataSource.sort.active = defaultSort.active;
            //     dataSource.sort.direction = defaultSort.direction;
            //     dataSource.sort.sortChange.emit(defaultSort);
            // } else {
            //     dataSource.sort.sortChange.emit(this.sorts.toArray()[index]);
            // }

            // Filter
            // dataSource.filterPredicate = (data: any, filter) => {
            //     const dataStr = JSON.stringify(data).toLowerCase();
            //     return dataStr.indexOf(filter) != -1;
            // };

            this.tableDataSources.push(dataSource);
        }, 100);
    }

    toggleAllStudents() {
        if (this.hasAtLeastOneStudent()) {
            this.graduatingStudents.forEach((student: any) => {
                if (!student.GRADUATED) {
                    student.ENABLED = false;
                }
            });
        } else {
            this.graduatingStudents.forEach((student: any) => {
                if (!student.GRADUATED) {
                    student.ENABLED = true;
                }
            });
        }
    }

    toggleStudent(student: any) {
        if (!student.GRADUATED) {
            student.ENABLED = !student.ENABLED;
        }
    }

    // Dialog function
    closeDialog(closed: boolean) {
        Swal.fire({
            titleText: 'Are you sure you want to continue without saving?',
            showDenyButton: false,
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Continue',
            cancelButtonText: 'Go Back',
            icon: 'warning',
            confirmButtonColor: '#3a6b35'
        }).then((result: any) => {
            if (result.isConfirmed) {
                this.dialogRef.close();
            }
        });
    }

    // Message functions
    getStudentName(student: any) {
        let name = '';

        if (student && student.PERSON) {
            name += student.PERSON.LAST_NAME;
            name += student.SECOND_LAST_NAME ? ' ' + student.SECOND_LAST_NAME : '';
            name += ', ' + student.PERSON.FIRST_NAME;
            name += student.PERSON.MIDDLE_INITIAL ? ' ' + student.PERSON.MIDDLE_INITIAL : '';

            name = this.titlecasePipe.transform(name);
        } else {
            name += '';
        }

        return name;
    }

    getTerminationMessage(student: any) {
        let msg = '';
        let studentFound = this.students.find((s: any) => s.ID === student.ID);

        if (studentFound && studentFound.STUDENT_TERMINATION_STATUSES && studentFound.STUDENT_TERMINATION_STATUSES.length > 0) {
            msg += 'Already Terminated (';
            msg += this.getPropertyPipe.transform(studentFound, 'STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES.TYPE');
            msg += ' on ';
            msg += this.simpleDatePipe.transform(this.getPropertyPipe.transform(studentFound, 'STUDENT_TERMINATION_STATUSES[0].STATUS_DATE'));
            msg += ')';
        } else {
            msg += 'Termination data not found.';
        }

        return msg;
    }

    getAlreadyGraduatedMessage(student: any) {
        let msg = '';
        let studentFound = this.students.find((s: any) => s.ID === student.ID);

        if (studentFound && studentFound.STUDENT_TERMINATION_STATUSES && studentFound.STUDENT_TERMINATION_STATUSES.length > 0) {
            msg += 'Already graduated on ';
            msg += this.simpleDatePipe.transform(this.getPropertyPipe.transform(studentFound, 'STUDENT_TERMINATION_STATUSES[0].STATUS_DATE'));
        } else {
            msg += 'Graduation data not found.';
        }

        return msg;
    }

    hasDifferentCounts() {
        return this.uniqueStudents.length !== this.resolveOnlyChosenStudents().length;
    }
}
